import { render } from "./RouteDashboard.vue?vue&type=template&id=a9971102&scoped=true"
import script from "./RouteDashboard.vue?vue&type=script&lang=js"
export * from "./RouteDashboard.vue?vue&type=script&lang=js"

import "./RouteDashboard.vue?vue&type=style&index=0&id=a9971102&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9971102"]])

export default __exports__